import { useEffect } from "react";
import { Link, useLocation, useSearchParams} from 'react-router-dom'

const SearchBar = ({
  searchString,
  setSearchString,
  setHashData
}) => {
  let [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  const { pathname } = location;
  
  const handleSearch = (event) => {
    setSearchString(event.target.value);
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      setSearchParams(`search=${searchString}`);
      setHashData({nodes: []})
    },  500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchString, setSearchParams]);

  return (
    <div className="searchForm">
      <div className="searchInput">
        <h2>Search by Address:</h2>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            setSearchParams(`search=${searchString}`);
          }}
        >
          <input
            id="search"
            type="text"
            value={searchString}
            onChange={handleSearch}
            autoComplete="off"
          />
        </form>
      </div>
      {console.log(pathname)}
      <div className="links">
        <Link className={`linkBtn ${pathname === "/phase_1" ? 'activeLnk' : ''}`} to={"/phase_1"}>With Dynamic Gas Cost</Link>
        <Link className={`linkBtn ${pathname === "/phase_2" ? 'activeLnk' : ''}`} to={"/phase_2"}>With Dynamic Gas Cost + Balanced DataTries</Link>
      </div>
    </div>
  );
};

export default SearchBar;
